import React from "react";
import { ajaxGet, requestPost } from "api/explus-api";
import Main from "../../Main";
import Paginate from "../../shared/Paginate";
import ReactPaginate from 'react-paginate';
import Swal from "sweetalert2";

class WeeklyDevotionContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            devotion_list: [],
            current_page: 1,
            page_count: 0,
            //next_url: '',
            //prev_url: '',
        };
        this.getDevotions = this.getDevotions.bind(this);
    }

    handleChange = e => {
    };

    componentDidUpdate(prevProps) {
    }

    componentDidMount() {
        this.initFetch();
    }

    async initFetch() {
        await ajaxGet("mobile/v2/devotions").then(data => {
            this.setState({ 
                devotion_list: data.data, 
                //current_page: data.current_page, 
                page_count: data.last_page, 
                //next_url: data.next_page_url, 
                //prev_url: data.prev_page_url 
            });
        });
    }

    isLoading() {
        this.setState({ loading: !this.state.loading });
    }

    async getDevotions({ selected: pageNumber }) {
        pageNumber = pageNumber + 1

        await ajaxGet("mobile/v2/devotions", pageNumber).then(data => {
            this.setState({ 
                devotion_list: data.data, 
                //current_page: data.current_page, 
                page_count: data.last_page, 
                next_url: data.next_page_url, 
                prev_url: data.prev_page_url 
            });
        });
    }

    render() {
        const numbers = [1, 2, 3, 4, 5];
        // const listItems = this.state.devotion_list.map((item, index) => { 

        //     return (
        //         <li key={index} className="list-group-item">
                    
        //             <h4 className="list-group-item-heading">
        //                 {item.title}
        //             </h4>
        //             {
        //             item.devo_date && 
        //             <small className="release-date">
        //                 <i
        //                     className="fa fa-calendar"
        //                     aria-hidden="true"
        //                 />{" "}
        //                 {item.devo_date}
        //             </small>
        //             }
        //             <p className="list-group-item-text">
        //                 {
        //                     item.url && 
        //                     <a href={item.url}>Read More</a>
        //                 }
        //             </p>
        //         </li>
            
        //         )
        // });
        let tableItems = this.state.devotion_list.map((item, index) => { 
            return (                
                <tr className="table-loader">
                    <td>{item.title}</td>
                    <td>
                                <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                            />{" "}
                            {item.devo_date}
                    </td>
                    <td>                
                        {
                            item.url && 
                            <a href="#read-more" onClick={(e) => viewDevotion(e, item)} className="weekly-devotion-readmore">Read More</a>
                        }
                    </td>
                </tr>
                )
        });

        function viewDevotion(e, data){
            e.preventDefault()
            const devotion_id = data.id
            const url = data.url

            Swal.fire("", "Retrieving data", "info");

            ajaxGet(`web/devotion/${devotion_id}/view`).then(data => {
                Swal.close()

                if(data.status === 'error'){
                    Swal.fire("", data.message, "error");
                }else if(data.status === 'success'){
                    window.open(url, '_blank');
                }
            })
        }

        return (
            <Main>
                <div className="row">

                {/* col-sm-8 col-sm-offset-2 */}
                    <div className="donor-column col-12">
                        <div className="my-updates-column text-left">
                            <h1 className="mb-5">Verse of the Week</h1>

                            
                            <table className="table table-striped table-bordered app-table">
                                <thead>
                                    <tr>
                                        <th>Scripture Reference</th>
                                        <th>Date</th>
                                        <th>Link</th>
                                    </tr>
                                </thead>
                                <tbody>{tableItems}</tbody>
                            </table>

                            <div className="text-center">
                            <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                pageCount= {this.state.page_count}//{pageCount}
                                pageRangeDisplayed={5}
                                onPageChange={this.getDevotions}
                                containerClassName={"pagination"}
                                previousLinkClassName={"pagination__link"}
                                nextLinkClassName={"pagination__link"}
                                disabledClassName={"pagination__link--disabled"}
                                activeClassName={"pagination__link--active active"}
                            />
                            </div>

                            {/* <ul className="list-group">
                                    {listItems}
                            </ul> */}
                        </div>
                    </div>
                </div>
            </Main>
        );
    }
}

export default WeeklyDevotionContainer;
